import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { FaChevronDown } from "react-icons/fa";
import { Nav, NavDropdown } from 'react-bootstrap'; // JSS

import { SitecoreLink } from '../link/Link';
import { mobileAppUtil } from '../../util/mobileAppUtil';
import SecondaryContainer from "./SecondaryContainer";
import { useHistory } from 'react-router-dom'; //MediaQuery

import MediaQuery from 'react-responsive';

var MenuItem = function MenuItem(props) {
  var item = props.item,
      index = props.index,
      active = props.active,
      activeMain = props.activeMain,
      setActiveMain = props.setActiveMain;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var _useState3 = useState(window.innerWidth),
      _useState4 = _slicedToArray(_useState3, 2),
      width = _useState4[0],
      setWidth = _useState4[1];

  var history = useHistory();

  var handleOpenMainMenu = function handleOpenMainMenu(props) {
    var e = props.e,
        url = props.url;
    e.stopPropagation();

    if (e.target.classList.contains('nav-link') && e.target.parentNode.classList.contains('show')) {
      if (activeMain === url) {
        if (typeof window !== 'undefined') {
          if (mobileAppUtil.isMobileApp()) {
            history.push(url);
          } else {
            return window.location = url;
          }
        }
      }
    } else {
      e.preventDefault();
      setActiveMain(url);
    }
  };

  var handleOpenMenu = function handleOpenMenu(props) {
    var e = props.e,
        index = props.index,
        hasChildren = props.hasChildren,
        hide = props.hide;
    e.stopPropagation();

    if (activeIndex === index && hide) {
      e.preventDefault();
      setActiveIndex(undefined);
      return;
    } // Open regular link if item has no children or of it is already active


    if (hasChildren === 'undefined') {
      return;
    }

    if (activeIndex !== index) {
      e.preventDefault();
      return setActiveIndex(index);
    }

    return true;
  };

  useEffect(function () {
    var newWidth = window.innerWidth;
    setWidth(newWidth);

    if (item.navigationTitle.value === 'Shop') {
      if (newWidth > 990) {
        setActiveIndex(0);
      } else {
        setActiveIndex(undefined);
      }
    } else {
      setActiveIndex(0);
    }
  }, []);
  var subItems = [];
  var subContent = [];

  if (item.children.length) {
    item.children.map(function (item, index) {
      var _item$children;

      if ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) {
        subItems[index] = item.children;
        subContent[index] = item;
      }
    });
  }

  var url = item.url;
  return /*#__PURE__*/React.createElement(React.Fragment, null, typeof item.navigationTitle !== 'undefined' && item.navigationTitle.value !== 'Shop' ? /*#__PURE__*/React.createElement("div", {
    id: "menuItem-".concat(item.url)
  }, /*#__PURE__*/React.createElement(NavDropdown, {
    as: "a",
    onClick: function onClick(e) {
      return handleOpenMainMenu({
        e: e,
        url: url
      });
    },
    href: item.url,
    "aria-controls": "submenu-".concat(index),
    title: item.navigationTitle.value,
    className: "\n              cb-menu__dropdown-container\n              ".concat(active ? 'is-current' : '', "\n            ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-menu__lists"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-menu__main-list"
  }, /*#__PURE__*/React.createElement(Nav, {
    as: "ul",
    id: "submenu-".concat(index),
    className: "cb-menu__main-subnav",
    role: "menu"
  }, item.children.map(function (item, index) {
    if (typeof item.navigationTitle !== 'undefined') {
      var _subItems$index, _subItems$index2, _subItems$index3;

      var model = {
        navigationTitle: item.navigationTitle.value,
        value: {
          href: item.url,
          title: item.navigationTitle.value,
          text: item.navigationTitle.value
        },
        children: item.children
      };
      var hasChildren = typeof subItems[index];
      var isActive = activeIndex === index;
      return /*#__PURE__*/React.createElement(NavDropdown.Item, {
        className: "\n                            cb-menu__main-link\n                            ".concat(((_subItems$index = subItems[index]) === null || _subItems$index === void 0 ? void 0 : _subItems$index.length) ? 'is-parent' : '', "\n                          "),
        as: "li",
        key: index,
        role: "menuitem"
      }, /*#__PURE__*/React.createElement("div", {
        className: "position-relative"
      }, /*#__PURE__*/React.createElement(SitecoreLink, {
        field: model,
        className: "\n                                  ".concat(isActive ? 'is-active' : '', "\n                                "),
        "aria-haspopup": typeof subItems[index] !== 'undefined' && ((_subItems$index2 = subItems[index]) === null || _subItems$index2 === void 0 ? void 0 : _subItems$index2.length) ? true : false,
        "aria-expanded": "false",
        "aria-controls": typeof subItems[index] !== 'undefined' && ((_subItems$index3 = subItems[index]) === null || _subItems$index3 === void 0 ? void 0 : _subItems$index3.length) ? "menu-".concat(index) : null,
        onClick: function onClick(e) {
          return handleOpenMenu({
            e: e,
            index: index,
            hasChildren: hasChildren
          });
        },
        id: "secondaryMenuItem-".concat(item.url)
      }), item.children.length > 0 && /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: 990
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(e) {
          return handleOpenMenu({
            e: e,
            index: index,
            hasChildren: hasChildren,
            hide: true
          });
        },
        className: "cb-menu__main-link__mobile-chevron"
      }, /*#__PURE__*/React.createElement(FaChevronDown, {
        className: isActive ? 'is-active' : ''
      })))), isActive && /*#__PURE__*/React.createElement(SecondaryContainer, {
        subItems: Array.isArray(subItems) ? subItems[index] : [],
        activeIndex: activeIndex,
        item: item,
        className: "is-mobile"
      }));
    }
  }))), /*#__PURE__*/React.createElement(SecondaryContainer, {
    subItems: subItems || [],
    activeIndex: activeIndex,
    item: item,
    subContent: subContent
  })))) : /*#__PURE__*/React.createElement("div", {
    id: "menuItem-".concat(item.url)
  }, /*#__PURE__*/React.createElement(NavDropdown, {
    as: "a",
    onClick: function onClick(e) {
      return handleOpenMainMenu({
        e: e,
        url: url
      });
    },
    href: item.url,
    "aria-controls": "submenu-".concat(index),
    title: item.navigationTitle.value,
    className: "\n              cb-menu__dropdown-container\n              ".concat(active ? 'is-current' : '', "\n            ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-menu__lists"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-menu__main-list"
  }, /*#__PURE__*/React.createElement(Nav, {
    as: "ul",
    id: "submenu-".concat(index),
    className: "cb-menu__main-subnav",
    role: "menu"
  }, item.children.map(function (item, index) {
    if (typeof item.navigationTitle !== 'undefined') {
      var _subItems$index4, _subItems$index5, _subItems$index6;

      var model = {
        navigationTitle: item.navigationTitle.value,
        value: {
          href: item.url,
          title: item.navigationTitle.value,
          text: item.navigationTitle.value
        },
        children: item.children
      };
      var hasChildren = typeof subItems[index];
      var isActive = activeIndex === index;
      return /*#__PURE__*/React.createElement(React.Fragment, null, item.children && /*#__PURE__*/React.createElement(NavDropdown.Item, {
        className: "\n                              cb-menu__main-link\n                              ".concat(((_subItems$index4 = subItems[index]) === null || _subItems$index4 === void 0 ? void 0 : _subItems$index4.length) ? 'is-parent' : '', "\n                            "),
        as: "li",
        key: index,
        role: "menuitem"
      }, /*#__PURE__*/React.createElement("div", {
        className: "position-relative"
      }, /*#__PURE__*/React.createElement(SitecoreLink, {
        field: model,
        className: "\n                                    ".concat(isActive ? 'is-active' : '', "\n                                  "),
        "aria-haspopup": typeof subItems[index] !== 'undefined' && ((_subItems$index5 = subItems[index]) === null || _subItems$index5 === void 0 ? void 0 : _subItems$index5.length) ? true : false,
        "aria-expanded": "false",
        "aria-controls": typeof subItems[index] !== 'undefined' && ((_subItems$index6 = subItems[index]) === null || _subItems$index6 === void 0 ? void 0 : _subItems$index6.length) ? "menu-".concat(index) : null,
        onClick: function onClick(e) {
          return handleOpenMenu({
            e: e,
            index: index,
            hasChildren: hasChildren
          });
        },
        id: "secondaryMenuItem-".concat(item.url)
      }), /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: 990
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(e) {
          return handleOpenMenu({
            e: e,
            index: index,
            hasChildren: hasChildren,
            hide: true
          });
        },
        className: "cb-menu__main-link__mobile-chevron"
      }, /*#__PURE__*/React.createElement(FaChevronDown, {
        className: isActive ? 'is-active' : ''
      })))), isActive && /*#__PURE__*/React.createElement(SecondaryContainer, {
        subItems: Array.isArray(subItems) ? subItems[index] : [],
        activeIndex: activeIndex,
        item: item,
        className: "is-mobile"
      })));
    }
  }))), /*#__PURE__*/React.createElement(SecondaryContainer, {
    subItems: subItems || [],
    activeIndex: activeIndex,
    item: item,
    subContent: subContent
  })))));
};

export default MenuItem;